import { getLocalStorageItem } from '../services/StorageService';
import { unlockLearnChangeUrlForDomains } from './constant';
import {
	envConfig,
	AI_BOT_APIM_BASE_URL,
	REPORTS_BASE_URL,
	UNLOCK_U_SERVER_PATH,
	UNLOCK_U_SERVER_INFO,
} from './envConstants';

const tenantData = JSON.parse(getLocalStorageItem('TenantData')) || {};

export const BaseUrl = envConfig.API_BASE_URL;
export const BaseBlobUrl = envConfig.BLOB_BASE_URL;
export const CoursesToken = process.env.REACT_APP_COURSES_TOKEN;
export const coursesBaseURL = envConfig.COURSES_API_ENDPOINT;

// infoprolearning domain uses a dedicated full URL; all other tenants use the
// path appended to their tenant learnUrl, or the trial override if set.
export const BaseUnlockU = Object.values(unlockLearnChangeUrlForDomains).includes(window.location.host.split('.')[0])
	? UNLOCK_U_SERVER_INFO
	: envConfig.UNLOCK_U_SERVER_OVERRIDE
	? envConfig.UNLOCK_U_SERVER_OVERRIDE
	: tenantData?.learnUrl
	? `${tenantData?.learnUrl}/${UNLOCK_U_SERVER_PATH}`
	: '';

export const BaseUnlockUToken = process.env.REACT_APP_UNLOCK_U_TOKEN;

// API suffix: '-' in prod means no suffix
const _rawSuffix = envConfig.API_SUFFIX;
export const apiEndpointSuffix = _rawSuffix === '-' ? '' : _rawSuffix || '';

export const TrialEnvApiUrl = 'https://unlockokr-apim-trial.azure-api.net';
/** notification */
export const NOTIFICATION_BASE_URL = `${BaseUrl}/notification${apiEndpointSuffix}/api/v2/OkrNotifications`;

/** user management  */
export const OkrUserManagement = `${BaseUrl}/user${apiEndpointSuffix}`;
export const OkrAuth = `${BaseUrl}/user${apiEndpointSuffix}`;
export const UserManagement = `${BaseUrl}/admin${apiEndpointSuffix}/api`;
export const TeamManagement = `${BaseUrl}/user${apiEndpointSuffix}`;
export const UnlockUServer = `${BaseUnlockU}`;

//Template Controller Letter
export const TemplateController = `${BaseUrl}/letter${apiEndpointSuffix}`;

/** okr management  */
export const OkrManagement = `${BaseUrl}/okr${apiEndpointSuffix}/api`;
export const OkrDBLogin = `${BaseUrl}?/Identity?`;

/** report  */
export const Reports = REPORTS_BASE_URL;

/** feedback */
export const FEEDBACK_BASE_URL = `${BaseUrl}/feedback${apiEndpointSuffix}/api`;

/** alignment */
export const AlignmentMap = `${BaseUrl}/okr${apiEndpointSuffix}/api`;

/** tenant */
export const Tenant = `${BaseUrl}/tenant${apiEndpointSuffix}`;

/**Guided Tour */
export const GuideTour = `${BaseUrl}/guidedtour${apiEndpointSuffix}/api/GuidedTour`;

/**Onboarding */
export const Onboarding = `${BaseUrl}/guidedtour${apiEndpointSuffix}/api/OnBoarding`;

/** Admin */
export const AdminRoles = `${BaseUrl}/user${apiEndpointSuffix}`;

/**Bilk CSV Template url */
export const BulkCsvTemplateUrl = `${BaseBlobUrl}/common/BulkUploadEmployeeTemplate.csv`;

/**Bulk Emails CSV Template url */
export const BulkEmailCsvTemplateUrl = `${BaseBlobUrl}/common/BulkEmailUpdateTemplate.csv`;

/**Bulk Goal Role CSV Template url */
export const BulkGoalRoleCsvTemplateUrl = `${BaseBlobUrl}/common/BulkGoalRoleUploadTemplate.csv`;

/**Bulk Assign Users CSV Template url */
export const BulkAssignUsersCsvTemplateUrl = `${BaseBlobUrl}/common/AssignBulkUsersTemplate.csv`;

/**Bulk Team CSV Template url */
export const BulkTeamCsvTemplateUrl = `${BaseBlobUrl}/common/TeamBulkUploadTemplate.csv`;

/**Self Assessment Guide Template Url */
export const SelfAssessmentGuideTemplateUrl = `${BaseBlobUrl}/common/Guide_for_Self_Assessment_Rubrics.pdf`;

/**Manager Assessment Guide Template Url */
export const ManagerAssessmentGuideTemplateUrl = `${BaseBlobUrl}/common/Guide_for_Managers_Enabling_questions.pdf`;

/**Final Assessment Guide Template Url*/
export const FinalAssessmentGuideTemplateUrl = `${BaseBlobUrl}/common/Guide_for_Potential_Rating.pdf`;

/** team management  */
export const OkrTeamManagement = `${BaseUrl}/user${apiEndpointSuffix}`;

/** okr reports  */
export const OkrReports = `${BaseUrl}/report${apiEndpointSuffix}`;

/** Task */
export const OkrTask = `${BaseUrl}/task${apiEndpointSuffix}`;

/** Notes */
export const okrNote = `${BaseUrl}/conversation${apiEndpointSuffix}`;

/** Conversations */
export const okrConversation = `${BaseUrl}/conversation${apiEndpointSuffix}`;

/** Checkins */
export const okrCheckins = `${BaseUrl}/conversation${apiEndpointSuffix}`;

// Trial Env Api
export const OkrTrialEnv = `${BaseUrl}/okrtrial${apiEndpointSuffix}`;

// Get about us details
export const versionDetails = `${UserManagement}/Master`;
//bulk user default okr
export const BulkUserDefaultCsvTemplateUrl = `${BaseBlobUrl}/common/ImportDefaultOKRTemplate.xlsx`;
/**Bilk CSV Template url */
export const BulkCsvGoalFormUrl = `${BaseBlobUrl}/common/BulkGoalFormUpload.csv`;
export const BulkKpiFormUrl = `${BaseBlobUrl}/common/ImportKpiTemplate.xlsx`;

//aiBot
const _rawUbotSuffix = envConfig.UBOT_API_SUFFIX;
export const ubotApiEndpointSuffix = _rawUbotSuffix === '-' ? '' : _rawUbotSuffix || '';
export const aiBotBaseUrl = AI_BOT_APIM_BASE_URL;
export const aiBotOKRBaseUrl = `https://aiauthor-api${ubotApiEndpointSuffix}.unlocku.com`;
export const ubotOKRORGID = envConfig.UBOT_ORGID;
export const ubotOKRProjectID = envConfig.UBOT_PROJECTID;
export const ubotOKRORGSecretKey = process.env.REACT_APP_UBOT_ORGSECRETKEY;

/**Synergita Feedback Backup Report Url*/
export const SynergitaFeedbackDumpReportUrl = `${BaseBlobUrl}/common/Feedback_Dump_Report.xlsx`;
export const SynergitaPIPSummaryReportUrl = `${BaseBlobUrl}/common/PIP_Summary_Report.xlsx`;
export const SynergitaPromotionStatusReportUrl = `${BaseBlobUrl}/common/Promotion_Status_Report.xlsx`;
export const SynergitaContinuousFeedbackReportUrl = `${BaseBlobUrl}/common/Continuous_Feedback_Report.xlsx`;
export const SynergitaPIPPDFReportUrl = `${BaseBlobUrl}/common/PIP_PDF_Report.zip`;
